import { Component, EventEmitter, HostListener, Input, Output, ViewEncapsulation } from '@angular/core';
import { FiltersService } from '../../../services/filters.service';
import { DistributionDataService } from '../../../services/distributionData.service';
import { ScrubberDataService } from '../../../services/scrubber.service';
import { PoolingPortalService } from '../../../services/pooling-portal.service';
import { Scrubber,LatestMonthYear, Filters } from '../../../interface/scrubber.interface';
import { Subscription, take } from 'rxjs';
import { AvgBunkerPriceData } from 'src/app/interface/lng.interface';
import { GoogleAnaylticsService } from 'src/app/services/google-anayltics.service';
import { GoogleAnalyticsEvents, GoogleAnalyticsModules } from '../utils/constants';
import { ToasterService } from 'src/app/services/toaster.service';

@Component({
  selector: 'app-scrubber',
  templateUrl: './scrubber.component.html',
  styleUrls: ['./scrubber.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ScrubberComponent {
  GoogleAnalyticsModules = GoogleAnalyticsModules;

  monthNameArray = this._poolingPortalService.getMonthShortNames();
  subscription: Subscription;

  Scrubber: Scrubber= {
    fleet: '',
    isSkelton : false,
    scbrDaysEditable : false,
    load : false,
    allSelect : false,
    download:true,
    date:new Date(),
    minDate:new Date(),
    maxDate:new Date(),
    scrubberData:[],
    allScrubberData: [],
    scbrDaysYtdData: [],
    subpool:[],
    shipOwners:[],
    owners:[],
    vslClass:[],
    ship:[],
    selectMonth: 0,
    selectYear: 0,
    sortBy:'',
    sortValue:'',
    iRole:0,
    selectDate:{
      month: 0, 
      year: 0
    },
  }
  
  filters: Filters  = {
    ship: [],
    shipOwners: [],
    vslClass: [],
    subpool: [],
    vslNumber: []    
  }

  latestData:LatestMonthYear ={
    lastMonth: 0,
    lastYear: 0,
    latestMonth: 0,
    latestYear: 0
  }
  shipNames: any = [];
  subPools: any = [];
  shipOwners: any = [];
  vslClasses: any = [];
  @Input() toggleVal:any;
  @Input() defaultActive:boolean;
  @Input() maxDate: Date;
  @Output() scrubberDatalist = new EventEmitter();
  @Output() toggleValue = new EventEmitter();
  @Output() showDropdownVal = new EventEmitter();
  getScrubberDatalist: any = [];
  month: any;
  year: number;
  newgetScrubberDatalist: any = [];
  showDropdown: boolean = false;
  monthToShow: string;
  yearToShow: number;
  config : {
    width : "auto"
    }
  getScrubberTotaldata: any = [];
  isCalculationOpen: boolean = false;
  isScrubberShipFormula:boolean = false;
  sidePanelScrubberData: any = [];
  calculationSidePanelHeaderName: string = 'Scrubber savings details';
  scrubberShipSidePanelHeaderName:string = '';
  scrubberShipNumber: any;
  scrubberShipSidePanelData: any = [];
  shipSidePanel:boolean = false;
  viewDetailsSidePanel:boolean = false;
  scrubberFailureinCurrentMonth: any;
  scrubberFailureinPreviousMonth: any;
  scrubberFailureMonth: any = [];
  scrubberDaysTableData:any= []
  scrubberDaysModal: boolean = false;
  scrubberDaysColumnHeader =[
    {'name':'No.', 'width': '58px'},
    {'name':'From', 'width': '144px'},
    {'name':'To', 'width': '144px'},
    {'name':'Duration (days)', 'width': '156px'},
    {'name':'Reason', 'width': '450px'}
  ];
 scrubberPoolPointColumnHeader = [
    {'name':"No.",'width': '58px'},
    {'name':"From",'width': '240px'},
    {'name':"Reason",'width': '654px'}]
  scrubberFailureVslNumber: string = '';
  scrubberFailureShipName: string = '';
  hasScrubberPointUpdateinCurrentMonth: any;
  checkScrubberVal: boolean;
  scrubberPoolPointsModal:boolean = false;
  scrubberPoolPointTableData: any = [];
  bunkerPriceHeaderName:string = 'Average bunker prices'
  isBunkerSectionOpen: boolean = false;
  getAvgBunkerPriceData: any = [];
  groupedByFiscalYear: [ string, AvgBunkerPriceData[] ][] = [];
  ownersLabel: any;
  isScrolled: boolean = false;
  // showViewBreakDownSidePanel: boolean = false;

  constructor( 
    private _filterService: FiltersService,
    private _distributionDataService: DistributionDataService,
    private _poolingPortalService: PoolingPortalService,
    private toasterService: ToasterService,
    private _scrubberDataService: ScrubberDataService,
    private _googleAnaylticsService: GoogleAnaylticsService
    ) {
  }
  ngOnInit() {
    console.log('scrubber on init')    
    this.Scrubber.isSkelton = true;    
    let filters = ['ship','shipOwners','subpool','vslClass','vslNumber'];
    filters.forEach( (it: any) => {
      this.filters[it] = [];
    });
    this.subscription = this._poolingPortalService.fleet$.subscribe(
      fleet => {
        this.Scrubber.isSkelton = true;
        this.Scrubber.load = false;
        this.Scrubber.fleet = fleet;
    })
  
    this.getOwnerList();
    this.shipNames = this._distributionDataService.filterdScrubberShipNames;
    this.subPools = this._distributionDataService.filteredScrubberSubPool;
    this.shipOwners = this._distributionDataService.filteredScrubberShipOwner;
    this.vslClasses = this._distributionDataService.filteredScrubberVslClass;
    this.month = this._distributionDataService.getMonth;
    this.monthToShow = this.maxDate.toLocaleString('en-US', { month: 'short' });
    this.yearToShow = this.maxDate.getFullYear();
    this.year = this._distributionDataService.getYear;
    
    this._distributionDataService.changeMonthYear.subscribe((res:any)=>{
      console.log('scrubber changeMonthYear', res)
      if(Object.keys(res).length > 0){
        let selectDate = new Date(res);
        let month = selectDate.getMonth() + 1;
        let year = selectDate.getFullYear();
        if((this.month !== month || this.year !== year) && this._distributionDataService.getSelectedPagetabVal() === "scrubber"){
          this.shipNames = [];
          this.shipOwners = [];
          this.subPools = [];
          this.vslClasses = [];
          this.filters.ship = [];
          this.filters.shipOwners = [];
          this.filters.subpool = [];
          this.filters.vslClass = [];
          this.month = selectDate.getMonth() + 1;
          this.year = selectDate.getFullYear();
          this.getOwnerList();
        }
        //User Story 106515: Updating the average bunker prices link to reflect the FY
        this.monthToShow = this.maxDate.toLocaleString('en-US', { month: 'short' });
        this.yearToShow = this.maxDate.getFullYear();
        if(month == 12){//december selected
          year++;
        }
        if(year < this.maxDate.getFullYear()){
          //show nov month and selected year
          this.monthToShow = 'Nov';
          this.yearToShow = year;
        }
      }
    });    
  }

  getScrubberData(latestYear:number,latestMonth:number) {
    let formData = {
      "month":this.month ? this.month : latestMonth,
      "year": this.year ? this.year : latestYear,
      "fleet": this.Scrubber.fleet
    };
    this._scrubberDataService.getScrubberData(formData)
      .subscribe({
        next: (res:any) => {
          if (res.data.getScrubberMonthlyData.success) {
            this.Scrubber.isSkelton = false;
            this.Scrubber.selectYear = latestYear;
            this.Scrubber.selectMonth = latestMonth;
            this.Scrubber.allScrubberData = res.data.getScrubberMonthlyData.data;  
            this.newgetScrubberDatalist = res.data.getScrubberMonthlyData.data;
            this.scrubberFailureMonth = res.data.getScrubberMonthlyData;
            if(this._distributionDataService.filterdScrubberListdata?.length){
              this.getScrubberDatalist = this._distributionDataService.filterdScrubberListdata;
              this.scrubberDatalist.emit(this._distributionDataService.filterdScrubberListdata);
            }else{
              this.getScrubberDatalist = res.data.getScrubberMonthlyData.data;
              this.scrubberDatalist.emit(this.getScrubberDatalist);
            }
            this.Scrubber.scrubberData =  this._filterService.filterItems(this.Scrubber.allScrubberData,this.filters);
            this.Scrubber.load = true;
            // this.Scrubber.scrubberData.sort(this.compareValues(this.Scrubber.sortBy,this.Scrubber.sortValue));
            this.applyFilter();
            this.refreshDropdownData();
          }
          else if(res.data.getScrubberMonthlyData.message == 'Access denied'){
            return;
          }
        }
      });  
  }

  getOwnerList() {
    this._distributionDataService.getOwnerList(this.Scrubber.fleet)
      .subscribe({
        next: (res:any) => {
          this.Scrubber.owners = res.data.getOwnersList.data.map((items:any)=>({id:items?.value,name:items.label}))
          this.Scrubber.shipOwners = this._filterService.shipOwners(this.Scrubber.allScrubberData,this.filters, this.Scrubber.owners);
          this.ownersLabel = this.Scrubber.owners.reduce((op,inp)=>{
            let key = inp.id
            let value = inp.name
            op[key] = value
            return op
          },{})
          this.getScrubberData(this.year,this.month);
          this.getScrubberTotalSavings(this.month,this.year);  
          this.getScrubberTotalSavingsSidePanel(this.year,this.month);        
        }
      });
  }

  public refreshDropdownData() {
     if(this.Scrubber.owners?.length){
      if(this.filters.ship['selectedRecords']?.length){
        this.filters.ship = this.filters.ship['selectedRecords'].map((record: any) => record.name);
      }
      if(this.filters.shipOwners['selectedRecords']?.length){
        this.filters.shipOwners = this.filters.shipOwners['selectedRecords'].map((record: any) => record.id);
      }
      this.Scrubber.shipOwners = this._filterService.shipOwners(this.Scrubber.allScrubberData,this.filters,this.Scrubber.owners);
      this.Scrubber.shipOwners = this.Scrubber.shipOwners.filter((obj:any, index:any, self:any) => index === self.findIndex((x:any) => x.id === obj.id));
    }
    if(this.filters.subpool['selectedRecords']?.length){
      this.filters.subpool = this.filters.subpool['selectedRecords'].map((record: any) => record.name);
    }
    if(this.filters.vslClass?.['selectedRecords']?.length){
      this.filters.vslClass = this.filters.vslClass['selectedRecords'].map((record: any) => record.id);
    }
    if (!this.filters.vslClass?.length || this.filters.vslClass?.length === undefined) {
      this.filters.vslClass = [];
    }
    this.Scrubber.ship = this._filterService.ships(this.Scrubber.allScrubberData, this.filters);
    this.Scrubber.subpool = this._filterService.subpools(this.Scrubber.allScrubberData, this.filters);
    this.Scrubber.subpool =  this.Scrubber.subpool.filter((obj:any, index:any, self:any) => index === self.findIndex((x:any) => x.id === obj.id));
    this.Scrubber.vslClass = this._filterService.vslClass(this.Scrubber.allScrubberData, this.filters);
    this.Scrubber.vslClass = this.Scrubber.vslClass.filter((obj:any, index:any, self:any) => index === self.findIndex((x:any) => x.id === obj.id));
  }

  public selectedValues(event:any,field:string){    
    this.filters[field] = event.selectedRecords?.map((items:any) =>items?.id);
    this.filters['vslNumber'] = [];
    this.refreshDropdownData();
    this.Scrubber.scrubberData =  this._filterService.filterItems(this.Scrubber.allScrubberData,this.filters);
     if(field === 'ship'){
      this.shipNames =  this.filters[field]?.map((items:any) =>({id:items,name:items}))
    }else if(field === 'subpool'){
        this.subPools =  this.filters[field]?.map((items:any) =>({id:items,name:items}))
    } else if(field === 'shipOwners'){
       this.shipOwners =  this.filters[field]?.map((items:any) =>({id:items,name:items}))
    } else if(field === 'vslClass'){
       this.vslClasses = this.filters[field]?.map((items:any) =>({id:items,name:items}))
    }
    this.showDropdown = false;
    this.showDropdownVal.emit(this.showDropdown)
    this.applyFilter();
  }
 
  applyFilter(){
    const selectedSubpools = (this.subPools || []).map((s:any) => s.id.toLowerCase().trim());
    const selectedShips = (this.shipNames || []).map((s:any) => s.name.toLowerCase().trim());
    const selectedOwners = (this.shipOwners || []).map((s:any) => s.id.toLowerCase().trim());
    const selectedClasses = (this.vslClasses || []).map((s:any) => s.id.toLowerCase().trim());
    this.getScrubberDatalist = this.newgetScrubberDatalist?.filter((items:any)=>
      (!selectedShips?.length || selectedShips?.includes(items?.vslName?.toLowerCase().trim())) && 
     (!selectedOwners?.length || selectedOwners?.includes(items?.vslOwner?.toLowerCase().trim())) && 
      (!selectedSubpools?.length||  selectedSubpools?.includes(items?.subPool?.toLowerCase().trim())) &&
      (!selectedClasses?.length || selectedClasses?.includes((items?.vslClass || '').toLowerCase().trim()))
    )
    this.scrubberDatalist.emit({filteredData:selectedSubpools?.length || selectedOwners?.length  || selectedShips?.length || selectedClasses?.length ? this.getScrubberDatalist : [],allData:this.newgetScrubberDatalist});
    this._distributionDataService.filterdScrubberShipNames =  this.shipNames?.length ?  this.shipNames : [];
    this._distributionDataService.filteredScrubberShipOwner = this.shipOwners?.length ? this.shipOwners : [];
    this._distributionDataService.filteredScrubberSubPool = this.subPools?.length ? this.subPools : [];
    this._distributionDataService.filteredScrubberVslClass = this.vslClasses?.length ? this.vslClasses : [];
     this.getScrubberDatalist = this.getScrubberDatalist.map((items: any) => {
      // const upadtedOffhiring = items?.map((data: any) => {
        if (this.toggleVal !== 'Monthly') {
          this.scrubberFailureinCurrentMonth = this.scrubberFailureMonth?.hasScrubberFailureinCurrentMonth?.some((x: any) => x?.toString().toLowerCase() == items?.vslCodeOwner?.toString().toLowerCase());
          this.scrubberFailureinPreviousMonth = this.scrubberFailureMonth?.hasScrubberFailureinPreviousMonth?.filter((x: any) =>
            !(this.scrubberFailureMonth?.hasScrubberFailureinCurrentMonth || [])?.includes(x));
          this.scrubberFailureinPreviousMonth = this.scrubberFailureinPreviousMonth?.some((x: any) => x?.toString().toLowerCase() == items?.vslCodeOwner?.toString().toLowerCase());
          this.hasScrubberPointUpdateinCurrentMonth = this.scrubberFailureMonth?.hasScrubberPointUpdateinCurrentMonth?.some((x: any) => x?.toString().toLowerCase() == items?.vslCodeOwner?.toString().toLowerCase());
        } else {
          this.scrubberFailureinCurrentMonth = this.scrubberFailureMonth?.hasScrubberFailureinCurrentMonth?.some((x: any) => x?.toString().toLowerCase() == items?.vslCodeOwner?.toString().toLowerCase());
          this.hasScrubberPointUpdateinCurrentMonth = this.scrubberFailureMonth?.hasScrubberPointUpdateinCurrentMonth?.some((x: any) => x?.toString().toLowerCase() == items?.vslCodeOwner?.toString().toLowerCase());

        }
        return items = {
          ...items, scrubberFailureinCurrentMonth: this.scrubberFailureinCurrentMonth,
          scrubberFailureinPreviousMonth: this.scrubberFailureinPreviousMonth,
          scrubberPointCurrentMonth:this.hasScrubberPointUpdateinCurrentMonth
        }
      // })
    })
    console.log(this.getScrubberDatalist)
  }

  public resetDropdown(event:any,field:string){
    if((this.shipNames?.length && field === 'ship') || (this.subPools?.length && field === 'subpool') || (this.shipOwners?.length && field === 'shipOwners') || (this.vslClasses?.length && field === 'vslClass')){
      this.filters[field] = [];
      this.Scrubber.scrubberData =  this._filterService.filterItems(this.Scrubber.allScrubberData,this.filters);
      this.refreshDropdownData();
      if (field === 'ship') {
        this.shipNames = [];
      } else if (field === 'subpool') {
        this.subPools = [];
      } else if (field === 'shipOwners') {
        this.shipOwners = [];
      } else if (field === 'vslClass') {
        this.vslClasses = [];
      }
      this.showDropdown = false;
      this.showDropdownVal.emit(this.showDropdown)
      this.applyFilter(); 
    }
  }

  public resetActivate(){
    return (this.shipNames?.length || this.shipOwners?.length || this.subPools?.length || this.vslClasses?.length) ? true : false;
  }
  
  public resetAll(){
    let filters = ['ship','shipOwners','subpool','vslClass'];
    filters.forEach( (it: any) => {
      this.filters[it] = [];
    });
    this.Scrubber.scrubberData=  this._filterService.filterItems(this.Scrubber.allScrubberData,this.filters);
    this.refreshDropdownData();
    this.shipNames = [];
    this.shipOwners = [];
    this.subPools = [];
    this.vslClasses = [];
    this.showDropdown = false;
    this.showDropdownVal.emit(this.showDropdown)
    this.applyFilter();
  }
  
  getYtdMonthlyVal(e: any) {
    this.toggleVal = e?.itemName;
    this.toggleValue.emit(this.toggleVal)
    // this.getModaldata();
    this.applyFilter();
    this._distributionDataService.changeToggle.next(true);  
  }

  getScrubberTotalSavings(latestYear:number,latestMonth:number){
    let obj = { 
      "fleet": this.Scrubber.fleet,
      "month":this.month ? this.month : latestMonth,
      "year": this.year ? this.year : latestYear,
    }
    this._scrubberDataService.getScrubberSavingsData(obj).pipe(take(1)).subscribe({
      next: (res:any)=>{
        this.getScrubberTotaldata = res?.data?.getFleetLevelScrubberSavings?.data;
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error)
      }
    })
  }
  getScrubberTotalSavingsSidePanel(latestYear:number,latestMonth:number){
    // this.showViewBreakDownSidePanel = false;
    this.sidePanelScrubberData = [];
    let obj = { 
      "fleet": this.Scrubber.fleet,
      "month":this.month ? this.month : latestMonth,
      "year": this.year ? this.year : latestYear,
    }
    this._scrubberDataService.getScrubberSavingsSidePanelData(obj).subscribe({
      next: (res:any)=>{
        this.sidePanelScrubberData =  res?.data?.getPoolLevelScrubberSavings;
        // this.showViewBreakDownSidePanel = true;
        console.log("in scrubber",this.sidePanelScrubberData )
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error)
      }
    })
  }

  getCalculationEvent(){
    this._googleAnaylticsService.triggerGTMEvent(GoogleAnalyticsEvents.VIEW_SCRUBBER_SAVINGS_FLEET);
    this.isCalculationOpen = true;
    this.shipSidePanel = false;
    this.viewDetailsSidePanel = true;
    this.isScrubberShipFormula = false;    
   
  }

  scrubberCalevent(data:any){
    this._googleAnaylticsService.triggerGTMEvent(GoogleAnalyticsEvents.OPEN_SHIP_SIDE_PANEL,{module:GoogleAnalyticsModules.SCRUBBER});
    this.isCalculationOpen = false;
    this.scrubberShipSidePanelData = [];
    this.isScrubberShipFormula =true;
    this.shipSidePanel = true;
    this.viewDetailsSidePanel = false;
    this.scrubberShipNumber = data?.vslNumber;
    this.scrubberShipSidePanelHeaderName = data?.vslName;
    this.getScrubberCalcEvent(this.latestData.latestYear,this.latestData.latestMonth)
  }
  
  getScrubberCalcEvent(latestYear:number,latestMonth:number){
     let obj = { 
      "fleet": this.Scrubber.fleet,
      "month":this.month ? this.month : latestMonth,
      "year": this.year ? this.year : latestYear,
      "vslNumber":  this.scrubberShipNumber
    }
    this._scrubberDataService.getScrubberShipSidePanelData(obj).subscribe({
      next: (res:any)=>{
        this.scrubberShipSidePanelData =  res?.data?.getShipLevelScrubberData;
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error)
      }
    })
  }

  scrubberFailureEvent(data:any,checkBooleanval:boolean){   
    this.isScrubberShipFormula = false;
    this.isCalculationOpen = false;
    this.scrubberFailureVslNumber = data?.vslNumber;
    this.scrubberFailureShipName = data?.vslName;
    this.checkScrubberVal = checkBooleanval;
    if(this.checkScrubberVal){
      this.scrubberDaysModal = true;
      this.scrubberDaysTableData = [];
      this._googleAnaylticsService.triggerGTMEvent(GoogleAnalyticsEvents.OPEN_SCRUBBER_DAYS_MODAL);
    }else{
      this.scrubberPoolPointsModal = true;
      this.scrubberPoolPointTableData = [];
    }
    this.getScrubberFailureEventsData(this.latestData.latestYear,this.latestData.latestMonth);
  }

  getScrubberFailureEventsData(latestYear:number,latestMonth:number){
     let obj = { 
      "vslNumber":  this.scrubberFailureVslNumber,
      "month":this.month ? this.month : latestMonth,
      "year": this.year ? this.year : latestYear,
      "toggleType": this.toggleVal
    }
    if(this.checkScrubberVal){
      this._scrubberDataService.getScrubberFailureEvent(obj).subscribe({
        next: (res:any)=>{
          this.scrubberDaysTableData =  res?.data?.getScrubberFailureEvents?.data;
        },
        error:(error:any)=>{
          this.toasterService.openToast('Error', error)
        }
      })
    }else{
      this._scrubberDataService.getScrubberPointEvent(obj).subscribe({
        next: (res:any)=>{
          this.scrubberPoolPointTableData =  res?.data?.getScrubberPointChanges?.data;
        },
        error:(error:any)=>{
          this.toasterService.openToast('Error', error)
        }
      })
    }    
  }
  viewBunkerPriceScrubber(){
  this._googleAnaylticsService.triggerGTMEvent(GoogleAnalyticsEvents.VIEW_AVERAGE_BUNKER_PRICE,{module:GoogleAnalyticsModules.SCRUBBER});
  this.isBunkerSectionOpen = true;
  this.viewBunkerPrice(this.latestData.latestYear,this.latestData.latestMonth)
  }
  viewBunkerPrice(latestYear:number,latestMonth:number){
    let payload = {
      "fleet": this.Scrubber.fleet,
      "month":this.month ? this.month : latestMonth,
      "year": this.year ? this.year : latestYear,
    }
    this._distributionDataService.viewBunkerPrice(payload);
    this._distributionDataService.$loadBunkerData.subscribe((res:any)=>{
      if(res){
        this.getAvgBunkerPriceData = res?.getAvgBunkerPriceData;
        this.groupedByFiscalYear = res?.groupedFiscalYear;
        console.log(this.getAvgBunkerPriceData)
        console.log(this.groupedByFiscalYear)
      }
    })
  }
  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isScrolled = scrollY > 400; 
  }
}